import React, { lazy, Suspense, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useVersionCheck, UpdateToast } from '@myapp/common-web-sdk';
import { AuthProvider } from './contexts/AuthContext';
import PushDebugLogger from './components/push/PushDebugLogger';

// Home page
import { HomePage } from './pages/home';

const CurrentUsersPage = lazy(() => import('./pages/current-users/CurrentUsersPage'));

function App() {
  const [showUpdateToast, setShowUpdateToast] = useState(false);

  useVersionCheck({ onOutdated: () => setShowUpdateToast(true) });

  return (
    <>
      <UpdateToast
        visible={showUpdateToast}
        onClose={() => setShowUpdateToast(false)}
      />
      <AuthProvider>
        <PushDebugLogger />
        <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/current-users" element={
              <Suspense fallback={<p role="status">正在加载页面…</p>}>
                <CurrentUsersPage />
              </Suspense>
            } />

            {/* 404 redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </>
  );
}

export default App;
